/**
 * Helper-functions for dataservices
 */

const helpers = {}

function generateFieldlist(fields) {
  return fields.reduce((list, field, idx) =>
    idx === 0 ? list + field : list + ',' + field
  , "fields=")
}

helpers.generateFieldlist = generateFieldlist

export default helpers;
